module.exports = __webpack_public_path__ + "static/media/bigtwo_1.213b01d8.png";